define([
    "./nlgTableModule",
    "./nlgTableDirective",
    "./nlgTableSortableColumn",
    "./tableSortFor",
    "./nlgTableButton/nlgTableButton"
], function(){
});